import React, { useState, useEffect } from 'react';
import { InfoCircleFill } from 'react-bootstrap-icons';
import ReactTooltip from 'react-tooltip';

const ClickableTooltip = ({ fetchText, style = {}, id }) => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleClick = async () => {
    if (isLoading) return; // Prevent clicks during loading
    setVisible((prev) => !prev);

    if (!content && typeof fetchText === 'function') {
      setIsLoading(true);
      try {
        const result = await fetchText();
        setContent(result || 'No content available');
      } catch {
        setContent('Error loading content.');
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    if (visible && content) {
      ReactTooltip.show(document.querySelector(`[data-for="${id}"]`));
    } else {
      ReactTooltip.hide(document.querySelector(`[data-for="${id}"]`));
    }
  }, [visible, content, id]);

  return (
    <>
      <InfoCircleFill
        data-for={id}
        data-tip={content}
        onClick={handleClick}
        style={{ ...style, cursor: isLoading ? 'wait' : 'pointer' }}
        fill="rgb(71, 96, 241)"
        aria-label="Toggle tooltip with description"
        role="button"
      />
      <ReactTooltip
        id={id}
      	className={"tooltip"} 
      	multiline={true} 
      	place="top" type="dark" effect="solid"
      	html
        clickable
        getContent={() => (isLoading ? 'Loading...' : content)}
      />
    </>
  );
};

export default ClickableTooltip;